export const PATH_SEPARATOR = '/';
export const ROOT_PATH = '';
export function isRootPath(path) {
    return path === ROOT_PATH || path === PATH_SEPARATOR;
}
